import isEqual from 'lodash/isEqual';

import { filtersObjectFromUrl } from '@common/utils/search-url-generator';

import {
  DEFAULT_FILTERS,
  DEFAULT_FILTERS_TRANSLATED_NO_SORT
} from '../constants';

import { getSortingName } from './sorting';

const isEqualFilter = (filters, filtersToCompare) =>
  Object.entries(filters).every(([key, value]) =>
    isEqual(filtersToCompare[key], value)
  );

export const adaptFilters = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return {
    bathrooms: filters['bathrooms[]'],
    bed: filters.bed,
    budget: filters.budget,
    features: filters['features[]'],
    moveIn: filters['move-in'],
    moveOut: filters['move-out'],
    flexibleMoveIn: parseInt(filters.flexibleMoveIn, 10),
    flexibleMoveOut: parseInt(filters.flexibleMoveOut, 10),
    topology: filters['topology[]'],
    type: filters['type[]'],
    page: filters.page,
    noDeposit: filters.noDeposit,
    instantBooking: filters.instantBooking,
    superLister: filters.superLister,
    plan: filters.plan,
    ids: filters['ids[]'],
    sortBy,
    poiLat: filters.poiLat && parseFloat(filters.poiLat),
    poiLng: filters.poiLng && parseFloat(filters.poiLng),
    verified: filters.verified,
    areaId: filters['areaId[]'],
    rentalType: filters['rentalType[]']
  };
};

export const adaptFiltersToUrl = (filters, sortingAlgorithm) => {
  const sortBy = getSortingName(filters.sortBy, sortingAlgorithm);

  return { ...filters, sortBy };
};

export const getInitialFilters = (originalUrl, areaInfo) => ({
  ...DEFAULT_FILTERS,
  ...filtersObjectFromUrl(originalUrl, areaInfo)
});

export const getDefaultFilters = () => DEFAULT_FILTERS;

export const isDefaultFilter = filters => {
  const { sortBy, ...restFilters } = filters;

  return isEqualFilter(restFilters, DEFAULT_FILTERS_TRANSLATED_NO_SORT);
};

export default {
  adaptFilters,
  adaptFiltersToUrl,
  getInitialFilters,
  getDefaultFilters,
  isDefaultFilter
};
